import CssBaseline from "@material-ui/core/CssBaseline";
import { Router } from "@reach/router";
import { LoginPage } from "./pages/Login";
import { Routes } from "./routes";
import { UserSessionProvider } from "./lib/session";
import { DashboardPage } from "./pages/Dashboard";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core";
import { Helmet } from "react-helmet";

// Import label and markdown styles.
import "./App.css";
import { URLPage } from "./pages/URLPage";
import { UserListPage } from "./pages/UserList";
import { UserStage } from "@authory-packages/core";
import { UserCountsContext } from "./lib/counts";
import { UserDetailsPage } from "./pages/UserDetailsPage";
import { SnackbarProvider } from "notistack";
import { ExpensiveSourceView } from "./pages/ExpensiveSourcesView";
import { UserCountsView } from "./pages/UserCountsView";

const theme = createMuiTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#2e77ff",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>Authory Backoffice</title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
      </Helmet>
      <SnackbarProvider
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        maxSnack={10}
      >
        <UserSessionProvider>
          <UserCountsContext>
            <>
              <CssBaseline />
              <div
                id="base-url-helper"
                data-base-url={process.env.REACT_APP_API_URL || ""}
              />
              <Router>
                <LoginPage path={Routes.Login} />
                <DashboardPage path={Routes.Dashboard} />
                <URLPage path={Routes.URl} />
                <UserListPage path={Routes.NewUsers} stage={UserStage.AllNew} />
                <UserListPage
                  path={Routes.StartedSignup}
                  stage={UserStage.NewSignup}
                />
                <UserListPage
                  path={Routes.FinishedSignup}
                  stage={UserStage.CompletedSignup}
                />
                <UserListPage
                  path={Routes.NewInProgress}
                  stage={UserStage.FullCrawlRunning}
                />
                <UserListPage
                  path={Routes.ImportFinished}
                  stage={UserStage.ImportFinished}
                />
                <UserListPage
                  path={Routes.AllActiveUsers}
                  stage={UserStage.AllActive}
                />
                <UserListPage path={Routes.ContCraw} stage={UserStage.Active} />
                <UserListPage
                  path={Routes.ActiveNewWebsite}
                  stage={UserStage.ActiveNewWebsite}
                />
                <UserListPage
                  path={Routes.ActiveFullCrawl}
                  stage={UserStage.ActiveFullCrawlRunning}
                />
                <UserListPage
                  path={Routes.ActiveImportFinished}
                  stage={UserStage.ActiveImportFinished}
                />
                <UserListPage
                  path={Routes.MarkedForDowngrade}
                  stage={UserStage.MarkedForDowngrade}
                />
                <UserListPage
                  path={Routes.InactiveUser}
                  stage={UserStage.Inactive}
                />
                <UserListPage
                  path={Routes.AwaitingFeedback}
                  stage={UserStage.ActiveAwaitingFeedback}
                />
                <UserListPage
                  path={Routes.SourceTuning}
                  stage={UserStage.SourceTuning}
                />
                <UserDetailsPage path={Routes.UserDetails} />
                <UserCountsView path={Routes.UserCounts} />
                <ExpensiveSourceView path={Routes.ExpensiveSources} />
              </Router>
            </>
          </UserCountsContext>
        </UserSessionProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
